const CLASSIFICATION_FILTERS = [
    { name: 'admission', label: 'Admission', options: [['', 'Any admission'], ['free', 'Free admission'], ['paid', 'Paid admission']] },
    { name: 'audience', label: 'Audience', options: [['', 'Any audience'], ['family_friendly', 'Family friendly'], ['adults_only', 'Adults only']] },
    { name: 'venue_setting', label: 'Venue setting', options: [['', 'Any setting'], ['indoor', 'Indoor'], ['outdoor', 'Outdoor'], ['mixed', 'Indoor + outdoor']] },
];

const selectClasses = 'mt-2 w-full rounded-xl border border-zinc-300 bg-white px-4 py-3 shadow-sm focus:border-fuchsia-500 focus:outline-none focus:ring-2 focus:ring-fuchsia-500/20 dark:border-zinc-600 dark:bg-zinc-800';

function activeClassificationLabels(params) {
    return CLASSIFICATION_FILTERS.flatMap((filter) => {
        const selectedValue = params.get(filter.name);
        const selectedOption = filter.options.find(([value]) => value !== '' && value === selectedValue);

        return selectedOption ? [`${filter.label}: ${selectedOption[1]}`] : [];
    });
}

function addActiveClassificationSummary(grid, labels) {
    if (labels.length === 0) return;

    const summary = document.createElement('div');
    summary.className = 'md:col-span-2 xl:col-span-3 rounded-xl border border-fuchsia-200 bg-fuchsia-50/70 px-4 py-3 text-sm text-fuchsia-950 dark:border-fuchsia-500/30 dark:bg-fuchsia-500/10 dark:text-fuchsia-100';
    summary.dataset.classificationFilterSummary = 'true';
    summary.setAttribute('role', 'status');

    const heading = document.createElement('strong');
    heading.textContent = labels.length === 1 ? '1 structured filter active' : `${labels.length} structured filters active`;

    const details = document.createElement('span');
    details.className = 'ml-2';
    details.textContent = labels.join(' · ');

    summary.append(heading, details);
    grid.prepend(summary);
}

function addClassificationFilters() {
    const duration = document.querySelector('form select[name="duration"]');
    if (!duration || document.querySelector('select[name="admission"]')) return;

    const grid = duration.closest('.ff-discovery-filter-fields');
    if (!grid) return;

    const params = new URLSearchParams(window.location.search);
    let insertionPoint = duration.closest('div');

    CLASSIFICATION_FILTERS.forEach((filter) => {
        const wrapper = document.createElement('div');
        const label = document.createElement('label');
        const select = document.createElement('select');
        const help = document.createElement('p');

        label.htmlFor = filter.name;
        label.className = 'block text-sm font-bold';
        label.textContent = filter.label;
        select.id = filter.name;
        select.name = filter.name;
        select.className = selectClasses;

        filter.options.forEach(([value, text]) => {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = text;
            option.selected = params.get(filter.name) === value;
            select.append(option);
        });

        help.className = 'mt-2 text-xs text-zinc-500 dark:text-zinc-400';
        help.textContent = 'Only organizer-confirmed festival information is used for this filter.';
        wrapper.append(label, select, help);
        insertionPoint.insertAdjacentElement('afterend', wrapper);
        insertionPoint = wrapper;
    });

    addActiveClassificationSummary(grid, activeClassificationLabels(params));
}

document.addEventListener('DOMContentLoaded', addClassificationFilters);
